interface RoleUser {
  role: string;
  email?: string;
}

export function isAdmin(user: RoleUser | null): boolean {
  return user?.role === 'admin';
}

export function isMember(user: RoleUser | null): boolean {
  return !!user && user.role !== 'admin';
}

export function canEditSalesPlaybook(user: RoleUser | null): boolean {
  return isAdmin(user);
}

export function canEditAgentSettings(user: RoleUser | null): boolean {
  return isAdmin(user);
}

export function canEditPipelineStages(user: RoleUser | null): boolean {
  return isAdmin(user);
}

export function canEditCompanyInfo(user: RoleUser | null): boolean {
  return isAdmin(user);
}

export function canDisconnectConnection(user: RoleUser | null, connectionUserId: string | null): boolean {
  if (!user) return false;
  if (isAdmin(user)) return true;
  return !!connectionUserId && connectionUserId === user.email;
}

export function canSeeBilling(user: RoleUser | null): boolean {
  return isAdmin(user);
}
